/* snappy-qa-modal.js
 * Replaces the inline .snappy-qa one-click add-to-cart with a popup modal
 * showing product image, title, price, variant picker, quantity stepper,
 * and an Add to Cart button (POST /cart/add.js).
 * Loaded on collection pages. Runs after the inline injection script.
 * Stock-limiting (gray out) is deferred until inventory numbers are set.
 */
(function () {
  'use strict';
  if (window.__snappyModalLoaded) return;
  window.__snappyModalLoaded = true;

  /* ---------- Brand palette / constants ---------- */
  var BLUE = '#0066FF';
  var BLUE_HOVER = '#0052CC';
  var GREEN = '#12b76a';
  var INK = '#1a1a1a';
  var MUTE = '#6b7280';
  var LINE = '#e5e7eb';

  /* ---------- Modal element (created once) ---------- */
  var overlay, sheet, closeBtn;

  function injectStyles() {
    if (document.getElementById('snappy-modal-css')) return;
    var s = document.createElement('style');
    s.id = 'snappy-modal-css';
    s.textContent = [
      '.snappy-modal-overlay{position:fixed;inset:0;background:rgba(17,17,17,.45);z-index:100000;display:flex;align-items:flex-end;justify-content:center;opacity:0;visibility:hidden;pointer-events:none;transition:opacity .2s ease,visibility .2s ease;font-family:inherit}',
      '.snappy-modal-overlay.open{opacity:1;visibility:visible;pointer-events:auto}',
      '.snappy-modal{background:#fff;width:100%;max-width:460px;border-radius:18px 18px 0 0;box-shadow:0 -8px 40px rgba(0,0,0,.22);padding:16px 18px calc(18px + env(safe-area-inset-bottom));transform:translateY(40px);transition:transform .25s cubic-bezier(.2,.8,.2,1);position:relative}',
      '.snappy-modal-overlay.open .snappy-modal{transform:translateY(0)}',
      '@media(min-width:640px){.snappy-modal-overlay{align-items:center}.snappy-modal{border-radius:18px;transform:scale(.96)}.snappy-modal-overlay.open .snappy-modal{transform:scale(1)}}',
      '.snappy-modal__handle{width:42px;height:4px;border-radius:2px;background:#d1d5db;margin:0 auto 14px}',
      '.snappy-modal__close{position:absolute;top:12px;right:12px;width:32px;height:32px;border-radius:50%;border:none;background:#f3f4f6;color:#374151;font-size:18px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0}',
      '.snappy-modal__close:hover{background:#e5e7eb}',
      '.snappy-product{display:flex;gap:14px;align-items:flex-start;margin-bottom:14px}',
      '.snappy-product__img{width:84px;height:84px;border-radius:12px;background:#f4f4f4;object-fit:cover;flex:0 0 auto}',
      '.snappy-product__img.placeholder{display:flex;align-items:center;justify-content:center;font-size:28px;color:#cbd5e1}',
      '.snappy-product__body{flex:1;min-width:0}',
      '.snappy-product__title{font-size:15px;font-weight:600;color:' + INK + ';line-height:1.3;margin:0 0 6px;word-wrap:break-word}',
      '.snappy-product__price{font-size:16px;font-weight:700;color:' + INK + '}',
      '.snappy-divider{height:1px;background:' + LINE + ';margin:0 -18px 14px}',
      '.snappy-variant-label{font-size:11px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;color:' + MUTE + ';margin-bottom:8px}',
      '.snappy-variants{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:16px}',
      '.snappy-variant{min-width:44px;padding:8px 14px;border:1.5px solid ' + LINE + ';border-radius:10px;background:#fff;color:' + INK + ';font-size:13px;font-weight:500;cursor:pointer;transition:all .15s ease}',
      '.snappy-variant:hover{border-color:#9ca3af}',
      '.snappy-variant.selected{border-color:' + INK + ';font-weight:700}',
      '.snappy-variant.disabled{opacity:.4;cursor:not-allowed;text-decoration:line-through}',
      '.snappy-qty-row{display:flex;align-items:center;justify-content:space-between;margin-bottom:16px}',
      '.snappy-qty-label{font-size:11px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;color:' + MUTE + '}',
      '.snappy-qty{display:flex;align-items:center;gap:0;border:1.5px solid ' + LINE + ';border-radius:10px;overflow:hidden}',
      '.snappy-qty button{width:38px;height:38px;border:none;background:#fff;color:' + INK + ';font-size:20px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center}',
      '.snappy-qty button:hover{background:#f4f4f4}',
      '.snappy-qty input{width:42px;height:38px;border:none;text-align:center;font-size:15px;font-weight:600;color:' + INK + ';-moz-appearance:textfield}',
      '.snappy-qty input::-webkit-outer-spin-button,.snappy-qty input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}',
      '.snappy-add{width:100%;height:50px;border:none;border-radius:12px;background:' + INK + ';color:#fff;font-size:15px;font-weight:700;letter-spacing:.04em;cursor:pointer;transition:background .15s ease,transform .1s ease}',
      '.snappy-add:hover{background:#000}',
      '.snappy-add:active{transform:scale(.98)}',
      '.snappy-add.adding{background:' + MUTE + ';cursor:wait}',
      '.snappy-add.done{background:' + GREEN + '}',
      '.snappy-status{font-size:12px;color:' + MUTE + ';text-align:center;min-height:16px;margin-top:8px}'
    ].join('\n');
    document.head.appendChild(s);
  }

  function buildModal() {
    if (overlay) return;
    injectStyles();
    overlay = document.createElement('div');
    overlay.className = 'snappy-modal-overlay';
    overlay.innerHTML =
      '<div class="snappy-modal" role="dialog" aria-modal="true">' +
      '<div class="snappy-modal__handle"></div>' +
      '<button class="snappy-modal__close" aria-label="Close">&times;</button>' +
      '<div class="snappy-product">' +
      '<img class="snappy-product__img placeholder" alt="">' +
      '<div class="snappy-product__body">' +
      '<h3 class="snappy-product__title"></h3>' +
      '<div class="snappy-product__price"></div>' +
      '</div>' +
      '</div>' +
      '<div class="snappy-divider"></div>' +
      '<div class="snappy-variant-wrap" style="display:none">' +
      '<div class="snappy-variant-label">Choose</div>' +
      '<div class="snappy-variants"></div>' +
      '</div>' +
      '<div class="snappy-qty-row">' +
      '<span class="snappy-qty-label">Quantity</span>' +
      '<div class="snappy-qty">' +
      '<button type="button" class="snappy-qty-minus" aria-label="Decrease">&minus;</button>' +
      '<input type="number" class="snappy-qty-input" value="1" min="1" inputmode="numeric">' +
      '<button type="button" class="snappy-qty-plus" aria-label="Increase">+</button>' +
      '</div>' +
      '</div>' +
      '<button class="snappy-add" type="button">Add to cart</button>' +
      '<div class="snappy-status"></div>' +
      '</div>';
    document.body.appendChild(overlay);
    closeBtn = overlay.querySelector('.snappy-modal__close');

    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
    closeBtn.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
  }

  function openModal() { buildModal(); overlay.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeModal() { if (!overlay) return; overlay.classList.remove('open'); document.body.style.overflow = ''; }

  /* ---------- helpers ---------- */
  function fmtPrice(cents) {
    try { return '$' + (cents / 100).toFixed(2); } catch (e) { return ''; }
  }

  function handleFromButton(btn) {
    var card = btn.closest('.product-card-wrapper, .card-wrapper, .card') || btn.closest('[class*="card"]');
    if (!card) return null;
    var as = card.getElementsByTagName('a');
    for (var i = 0; i < as.length; i++) {
      var h = as[i].getAttribute('href') || '';
      var idx = h.indexOf('/products/');
      if (idx > -1) return h.substring(idx + 10).split('/')[0].split('?')[0].split('#')[0];
    }
    return null;
  }

  function updateCartCount() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var a = document.getElementById('cart-icon-bubble');
        if (!a) return;
        var b = a.querySelector('.cart-count-bubble');
        if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; a.appendChild(b); }
        b.innerHTML = '<span aria-hidden="true">' + c.item_count + '</span>';
        if (window.jQuery) { try { jQuery(document).trigger('cart:updated', c); } catch (e) {} }
      }).catch(function () {});
  }

  /* ---------- per-open state ---------- */
  var state = { product: null, variant: null, qty: 1 };

  function renderProduct(p) {
    state.product = p;
    state.qty = 1;

    var img = overlay.querySelector('.snappy-product__img');
    var pi = (p.featured_image || (p.images && p.images[0]));
    if (pi) {
      img.src = typeof pi === 'string' ? pi : pi.url;
      img.classList.remove('placeholder');
      img.textContent = '';
    } else {
      img.classList.add('placeholder');
      img.textContent = '\u{1F4CD}'; // bag-ish placeholder glyph
      img.removeAttribute('src');
    }

    overlay.querySelector('.snappy-product__title').textContent = p.title;
    var available = (p.variants || []).filter(function (v) { return v.available; });
    var first = available[0] || (p.variants || [])[0];
    state.variant = first;
    overlay.querySelector('.snappy-product__price').textContent = fmtPrice(first.price);

    // variants
    var wrap = overlay.querySelector('.snappy-variant-wrap');
    var box = overlay.querySelector('.snappy-variants');
    box.innerHTML = '';
    var multi = (p.variants || []).length > 1 ||
      (p.variants && p.variants[0] && p.variants[0].title && p.variants[0].title !== 'Default Title');
    if (multi) {
      wrap.style.display = '';
      (p.variants || []).forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'snappy-variant' + (v.id === first.id ? ' selected' : '') + (v.available ? '' : ' disabled');
        b.textContent = v.title;
        b.disabled = !v.available;
        b.addEventListener('click', function () {
          if (!v.available) return;
          state.variant = v;
          box.querySelectorAll('.snappy-variant').forEach(function (x) { x.classList.remove('selected'); });
          b.classList.add('selected');
          overlay.querySelector('.snappy-product__price').textContent = fmtPrice(v.price);
        });
        box.appendChild(b);
      });
    } else {
      wrap.style.display = 'none';
    }

    // reset qty
    overlay.querySelector('.snappy-qty-input').value = 1;

    // reset add button
    var add = overlay.querySelector('.snappy-add');
    add.textContent = 'Add to cart';
    add.classList.remove('adding', 'done');
    add.disabled = false;
    overlay.querySelector('.snappy-status').textContent = '';
  }

  function wireQty() {
    var input = overlay.querySelector('.snappy-qty-input');
    var minus = overlay.querySelector('.snappy-qty-minus');
    var plus = overlay.querySelector('.snappy-qty-plus');
    function set(n) {
      n = Math.max(1, parseInt(n, 10) || 1);
      state.qty = n;
      input.value = n;
    }
    minus.onclick = function () { set(state.qty - 1); };
    plus.onclick = function () { set(state.qty + 1); };
    input.onchange = function () { set(input.value); };
  }

  function wireAdd() {
    var add = overlay.querySelector('.snappy-add');
    add.onclick = function () {
      if (!state.variant || !state.variant.available) {
        overlay.querySelector('.snappy-status').textContent = 'This option is unavailable.';
        return;
      }
      add.classList.add('adding');
      add.disabled = true;
      add.textContent = 'Adding\u2026';
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: state.variant.id, quantity: state.qty }] })
      }).then(function (r) { return r.json(); }).then(function () {
        return updateCartCount();
      }).then(function () {
        add.classList.remove('adding');
        add.classList.add('done');
        add.textContent = 'Added \u2713';
        // flash the source button too
        if (state.sourceBtn) {
          state.sourceBtn.textContent = '\u2713';
          state.sourceBtn.classList.add('added');
          setTimeout(function () {
            state.sourceBtn.textContent = '+';
            state.sourceBtn.classList.remove('added');
          }, 1300);
        }
        setTimeout(function () {
          add.textContent = 'Add to cart';
          add.classList.remove('done');
          add.disabled = false;
          closeModal();
        }, 850);
      }).catch(function () {
        add.classList.remove('adding');
        add.disabled = false;
        add.textContent = 'Add to cart';
        overlay.querySelector('.snappy-status').textContent = 'Something went wrong. Try again.';
      });
    };
  }

  function openForButton(btn) {
    openModal();
    var handle = handleFromButton(btn);
    if (!handle) { closeModal(); return; }
    // loading state
    overlay.querySelector('.snappy-product__title').textContent = 'Loading\u2026';
    overlay.querySelector('.snappy-product__price').textContent = '';
    overlay.querySelector('.snappy-variant-wrap').style.display = 'none';
    overlay.querySelector('.snappy-add').disabled = true;
    overlay.querySelector('.snappy-add').textContent = 'Loading\u2026';
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        state.sourceBtn = btn;
        renderProduct(p);
        wireQty();
        wireAdd();
      }).catch(function () {
        overlay.querySelector('.snappy-product__title').textContent = 'Could not load product';
        overlay.querySelector('.snappy-add').textContent = 'Close';
        overlay.querySelector('.snappy-add').disabled = false;
        overlay.querySelector('.snappy-add').onclick = closeModal;
      });
  }

  /* ---------- bulletproof capture-phase click intercept ----------
   * A single document-level listener in the CAPTURE phase fires before the
   * inline injection script's own click handlers, so the popup always wins
   * regardless of when (or whether) the inline buttons were created. No cloning,
   * no timing dependencies. Works on every page where .snappy-qa buttons appear.
   */
  function onSnappyClick(e) {
    var t = e.target;
    var btn = (t && t.closest) ? t.closest('.snappy-qa') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (btn.disabled) return;
    openForButton(btn);
  }

  function init() {
    injectStyles();
    buildModal();
    document.addEventListener('click', onSnappyClick, true); // capture phase
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
